module.exports = __webpack_public_path__ + "img/quick_style.5fcf5b3f.svg";